import React from "react";
import { useTwoColumnContainerStyles } from "../TwoColumnContainer.styles";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";

export interface RightColumnProps {
    children: React.ReactNode;
}

function RightColumn(props: RightColumnProps) {
    const styles = useTwoColumnContainerStyles();
    return (
        <Grid sx={styles.grid} size={{ md: 6 }}>
            <Box
                sx={[
                    styles.commonContainer,
                    {
                        paddingBottom: 0,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                    },
                ]}
            >
                {props.children}
            </Box>
        </Grid>
    );
}

export default RightColumn;
